import { render, staticRenderFns } from "./MultiGraphPage.vue?vue&type=template&id=1931857b&"
import script from "./MultiGraphPage.vue?vue&type=script&lang=js&"
export * from "./MultiGraphPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports